/**
 * AudioEmptyValidator class is responsible for validating if the audio content of a model is empty.
 * It uses AngularJS's $translate service to handle error messages.
 */
class AudioEmptyValidator {
    /**
     * Constructs an instance of AudioEmptyValidator.
     * @param {Object} $injector - The AngularJS injector service.
     * @param {Object} model - The model to be validated.
     */
    constructor($injector, model) {
        this.$injector = $injector;
        this.model = model;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.AUDIO';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazy-loads the $translate service from the injector.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model to check if its audio content is empty.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} An object containing validation details.
     */
    validate(from) {
        let isError = this.model.isContentEmpty();

        // If the model is empty and has no parents, it's not considered an error.
        if (isError && this.model.getParents().length === 0) {
            isError = false;
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            isError,
            'status':           isError ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Gets the error message for an empty audio content.
     * @returns {string} The translated error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if a forced validation check is set.
     * @returns {boolean} The status of the forced check.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'AudioEmptyValidator';
    }
}

export default AudioEmptyValidator;